import { Field, Formik } from "formik";

import React, { useContext, useState } from "react";
import { FormLabel } from "react-bootstrap";
import { AuthContext } from "../Auth/Context/AuthContext";
import { loginValidation } from "../config/Validations";
import User from "../Services/userServices";

function Login(props) {
  const { setUser } = useContext(AuthContext);

  const [serverError, setServerError] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [isLoading, setIsloading] = useState(false);

  const logginIn = async (values, { setSubmitting, setFieldError }) => {
    setIsloading(true);
    await User.signin(values.email, values.password)
      .then(async (response) => {
        setIsloading(false);
        const token = response.data;
        localStorage.setItem("access_token", token);
        await User.getLoggedUser(token).then((user) => {
          const jsonUser = JSON.stringify(user);
          localStorage.setItem("user", jsonUser);
          setUser(user);
          user && window.location.reload();
        });
        setResponseMessage(response?.message);
      })
      .catch((err) => {
        setIsloading(false);
        setResponseMessage(err?.response.data.error);
        setSubmitting(false);
        if (!err.response) {
          setServerError("Error occured please try later");
        } else {
          const { data } = err.response;
          if (data?.statusCode == 404)
            setFieldError("username", "User does not exist");
          if (data?.statusCode == 401)
            setFieldError("password", "Incorrect password");
        }
      });
  };

  return (
    <div class="main-wrapper">
      <div class="account-content">
        <div class="login-wrapper">
          <div class="login-content">
            <div class="login-userset">
              <div class="login-logo">
                <img src="/assets/img/logo.png" alt="img" />
              </div>
              <div class="login-userheading" style={{ display: "flex" }}>
                <h3>Sign In</h3>
                <h4>Please login to your account</h4>
                {isLoading && (
                  <div
                    id="global-loader"
                    style={{ background: "none", width: "33%", height: "50%" }}
                  >
                    <div class="whirly-loader"> </div>
                  </div>
                )}
              </div>
              <p style={{ color: "red" }}>{responseMessage}</p>

              <Formik
                enableReinitialize
                initialValues={{ email: "", password: "" }}
                onSubmit={logginIn}
                validationSchema={loginValidation}
              >
                {({ errors, touched, handleSubmit }) => (
                  <>
                    <div class="form-login">
                      <FormLabel>Email</FormLabel>
                      <div class="form-addons">
                        <Field
                          type="email"
                          placeholder="Enter your email or username"
                          name="email"
                        />
                        <img src="/assets/img/icons/mail.svg" alt="img" />
                      </div>
                      {errors.email && touched.email && (
                        <p style={{ color: "red" }}>{errors.email}</p>
                      )}
                    </div>
                    <div class="form-login">
                      <FormLabel>Password</FormLabel>
                      <div class="pass-group">
                        <Field
                          type="password"
                          className="pass-input"
                          name="password"
                          placeholder="**********"
                        />
                        <span class="fas toggle-password fa-eye-slash"></span>
                      </div>
                      {errors.password && touched.password && (
                        <p style={{ color: "red" }}>{errors.password}</p>
                      )}
                    </div>
                    <div class="form-login">
                      <div class="alreadyuser">
                        <h4>
                          <a href="forgetpassword.html" class="hover-a">
                            Forgot Password?
                          </a>
                        </h4>
                      </div>
                    </div>
                    <div class="form-login">
                      <button class="btn btn-login" onClick={handleSubmit}>
                        Sign In
                      </button>
                    </div>
                  </>
                )}
              </Formik>
            </div>
          </div>
          <div class="login-img">
            <img src="/assets/img/login.jpg" alt="img" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
